export default [
  {
    path: '/koreksi/pengembalian',
    redirect: '/koreksi/pengembalian',
    name: 'koreksiPengembalian',
    component: () => import('@/views/NestedRoute.vue'),
    children: [
      {
        path: '',
        name: 'koreksiPengembalianIndex',
        component: () => import('@/views/koreksi/pengembalian/Index.vue'),
        meta: {
          action: 'Lihat',
          resource: 'koreksi-pengembalian',
          pageTitle: 'Pengembalian',
          breadcrumb: [
            { text: 'Koreksi' },
            { text: 'Status Inventarisasi', active: true },
          ],
        },
      },
      {
        path: '/koreksi/pengembalian/tambah',
        name: 'koreksiPengembalianTambah',
        component: () => import('@/views/koreksi/pengembalian/Tambah.vue'),
        meta: {
          action: 'Buat',
          resource: 'koreksi-pengembalian',
          pageTitle: 'Pengembalian',
          breadcrumb: [
            { text: 'Koreksi' },
            { text: 'Status Inventarisasi' },
            { text: 'Tambah', active: true },
          ],
        },
      },
    ],
  },
]
